const timeAtJob = [
  {
    value: 'less_than_1_month',
    text:  'Menos de 1 mês',
  },
  {
    value: '1_to_3_months',
    text:  '1 a 3 meses',
  },
  {
    value: '4_to_6_months',
    text:  '4 a 6 meses',
  },
  {
    value: '6_months_to_1_year',
    text:  '6 meses a 1 ano',
  },
  {
    value: '1_year_to_2_years',
    text:  '1 ano a 2 anos',
  },
  {
    value: 'more_than_2_years',
    text:  'Mais de 2 anos',
  },
];
export default timeAtJob;
